import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import Homepage from "../components/Homepage/Homepage";
import ProjectPage from "../components/ProjectPage/ProjectPage";
import Header from "../components/Header/Header";
import createHistory from "history/createBrowserHistory";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import ReactGA from "react-ga";
import AboutUs from "../components/AboutUs/AboutUs";

ReactGA.initialize("UA-112735879-1");

export const history = createHistory();

const historyListener = location => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
};

history.listen(historyListener);
historyListener(history.location);

const AppRouter = () => (
  <Router history={history}>
    <div>
      <Header history={history} />
      <Switch>
        <ScrollToTop>
          <Route path="/" component={Homepage} exact />
          <Route path="/about-us" component={AboutUs} />
          <Route path="/project/:slug" component={ProjectPage} />
        </ScrollToTop>
      </Switch>
    </div>
  </Router>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js